import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AuthLayoutComponent } from "./auth-layout.component";
import { SocialMediaModule } from "@app/shared/social-media/social-media.module";
import { RouterModule } from "@angular/router";
import { IconModule } from "@app/modules/@cdk";

@NgModule({
  declarations: [AuthLayoutComponent],
  imports: [CommonModule, SocialMediaModule, RouterModule, IconModule],
  exports: [AuthLayoutComponent],
})
export class AuthLayoutModule {}
